"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/main.ts');
require("core-js/es7/reflect");
const core_1 = require("@angular/core");
// import { AppMakerModule } from './app/app-maker.module';
const environment_1 = require("./environments/environment");
require("hammerjs");
const __NgCli_bootstrap_1 = require("./app/app.module.ngfactory");
const __NgCli_bootstrap_2 = require("@angular/platform-browser");
window['CESIUM_BASE_URL'] = '/assets/cesium/';
if (environment_1.environment.production) {
    core_1.enableProdMode();
}
// EVERYTHING is starting from here
DEBUG_1.DEBUG.log('/main.ts', 'BOOTSTRAPPING AppModule');
__NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory).catch(err => console.error(err));
/* for debugging tools
platformBrowserDynamic().bootstrapModule(AppModule)
  .then(module => enableDebugTools(module.injector.get(ApplicationRef).components[0]))
  .catch(err => console.error(err)); */ 
